<template>
  <div class="dataTables_wrapper form-inline dt-bootstrap" id="example1_wrapper">
    <div class="row">
      <div class="col-sm-6 text-left">
        <div class="form-group text-left">
          <div class="btn btn-default btn-table-title" @click="outputList">匯出店家時間內拆帳</div>
        </div>
      </div>
      <div class="col-sm-6 text-right">
        <div class="form-group">
          <select class="form-control h-38" v-model="searchSelect">
            <option value="1">時間</option>
          </select>
        </div>
        <div class="form-group input-group time-box" v-if="searchSelect == 1">
          <date-time-picker :date="menuTime.start" :option="dateoption" :limit="startLimit"></date-time-picker>
          <date-time-picker :date="menuTime.end" :option="dateoption" :limit="endLimit"></date-time-picker>
          <!--<input type="text" class="form-control time-picker" id="start-box" placeholder="起始時間">-->
          <!--<input type="text" class="form-control time-picker" id="end-box" placeholder="結束時間">-->
          <span class="input-group-btn">
            <button class="btn btn-default submit-btn btn-search" type="button"
                    id="search" style="height: 72px" @click="getRangeHistory(1)">
              <i class="fa fa-search"></i>
            </button>
          </span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12" v-if="info.brandId">
        <div class="box-body form-left min-m-t-10">
          <div>
            <div class="input-group">
              <span class="input-group-addon">品牌名稱(ID)</span>
              <div class="form-control form-info">
                {{info.brandName}} ({{info.brandId}})
              </div>
            </div>
            <br />
          </div>
        </div>
        <div class="box-body form-right min-m-t-10">
          <div>
            <div class="input-group">
              <span class="input-group-addon">店家名稱(ID)</span>
              <div class="form-control form-info">
                {{info.storeName}} ({{info.storeId}})
              </div>
            </div>
            <br />
          </div>
        </div>
      </div>
      <div class="col-sm-12 table-responsive p-x-0">
        <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
          <thead>
          <tr role="row">
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">#</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">下訂日期</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">訂單總數</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">訂單總金額</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">店家實得款項金額</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">Matcher手續費</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">完成過帳筆數</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="" ></th>
          </tr>
          </thead>
          <tbody>
          <tr class="even" role="row" v-for="(history, index) in historyList">
            <td class="sorting_1">
              <span>{{index + 1}}</span>
            </td>
            <td>{{history.order_date}}</td>
            <td>{{history.total_order_count}}</td>
            <td>$ {{history.total_order_money}}</td>
            <td>$ {{history.total_store_revenue}}</td>
            <td>$ {{history.total_matcher_revenue}}</td>
            <td>{{history.total_posted_count}}</td>
            <td>
              <router-link :to="{path: '/oneDayHistoryTable/' + history.brand_id + '/' + history.store_id + '/' + history.order_date}">
                <button class="btn btn-default"><i class="fa fa-info-circle" aria-hidden="true"></i></button>
              </router-link>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <!--<div class="col-xs-12 text-center">-->
        <!--<ul class="pagination">-->
          <!--<li class="paginate_button" v-for="index in pageAmount" :class="{active: isActive(index)}" @click="clickPage(index)">-->
            <!--<a class="c-pointer">{{index}}</a>-->
          <!--</li>-->
        <!--</ul>-->
      <!--</div>-->
    </div>
  </div>
</template>
<script>
import datetimePicker from 'vue-datepicker/vue-datepicker-es6.vue'
import moment from 'moment'
export default{
  components: {
    'date-time-picker': datetimePicker
  },
  data () {
    return {
      total: 1,
      count: 31,
      historyList: [],
      tableIndex: 1,
      searchSelect: 1,
      storeId: this.$route.params.store_id,
      info: {
        brandId: '',
        brandName: '',
        storeId: '',
        storeName: ''
      },
      // date
      menuTime: {
        start: {
          time: ''
        },
        end: {
          time: moment().add(1, 'days').format('YYYY-MM-DD')
        }
      },
      dateoption: {
        type: 'day',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      },
      startLimit: [
        {
          type: 'fromto',
          to: moment().format('YYYY-MM-DD')
        }
      ],
      endLimit: [
        {
          type: 'fromto',
          to: moment().add(1, 'days').add(1, 'days').format('YYYY-MM-DD')
        }
      ]
    }
  },
  methods: {
    isActive (index) {
      if (this.tableIndex === index) return true
      else return false
    },
    getRangeHistory (index) {
      var self = this
      var info = self.info
      if (index) this.tableIndex = index
      var date = {
        start: moment(this.menuTime.start.time, 'YYYY-MM-DD').format('YYYYMMDD'),
        end: moment(this.menuTime.end.time, 'YYYY-MM-DD').format('YYYYMMDD')
      }
      var url = 'history/rangeHistory' + '?start_date=' + date.start + '&end_date=' + date.end + '&store_id=' + this.storeId
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.historyList = response.data.history_list
          // self.total = response.data.total
          if (self.historyList.length) {
            for (let key in self.historyList) {
              info.brandId = self.historyList[key].brand_id
              info.brandName = self.historyList[key].brand_name
              info.storeId = self.historyList[key].store_id
              info.storeName = self.historyList[key].store_name
              break
            }
          }
        }
      })
    },
    outputList () {
      var date = {
        start: moment(this.menuTime.start.time, 'YYYY-MM-DD').format('YYYYMMDD'),
        end: moment(this.menuTime.end.time, 'YYYY-MM-DD').format('YYYYMMDD')
      }
      var url = 'history/rangeHistorySheets' + '?page=' + this.tableIndex + '&size=' + this.count + '&start_date=' + date.start + '&end_date=' + date.end + '&store_id=' + this.storeId
      this.getFile('get', url, null, function (response) {
        // window.location = response
        var blob = new Blob([response.data], {type: 'application/vnd.ms-excel'})
        var objectUrl = URL.createObjectURL(blob)
        var a = document.createElement('a')
        a.href = objectUrl
        a.download = 'report.xls'
        document.body.appendChild(a)
        a.click()
      })
    }
  },
  created () {
    var date = new Date()
    var y = date.getFullYear()
    var m = date.getMonth()
    var firstDay = new Date(y, m, 1)
    this.menuTime.start.time = moment(firstDay).format('YYYY-MM-DD')
    this.getRangeHistory()
  },
  watch: {
    'menuTime.end.time' () {
      var lastDay = moment(this.menuTime.end.time, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD')
      if (this.menuTime.start.time > lastDay) this.menuTime.start.time = lastDay
      this.startLimit = [
        {
          type: 'fromto',
          to: lastDay
        }
      ]
    },
    'menuTime.start.time' () {
      var lastDay = moment(this.menuTime.start.time).add('31', 'days')
      if (lastDay < moment()) this.menuTime.end.time = lastDay.format('YYYY-MM-DD')
      else this.menuTime.end.time = moment().add(1, 'days').format('YYYY-MM-DD')
      this.endLimit = [
        {
          type: 'fromto',
          from: this.menuTime.start.time,
          to: this.menuTime.end.time
        }
      ]
    }
  },
  computed: {
    getFile () {
      return this.$parent.getFile
    },
    getDataH () {
      return this.$parent.getDataH
    },
    pageAmount () {
      return Math.ceil(this.total / this.count)
    }
  }
}
</script>



// WEBPACK FOOTER //
// HistoryTableTemp.vue?ac23fc40